import "./Banner.scss";

import { Flex, Header, Text } from "@fluentui/react-northstar";
import React from "react";

import { PollyIcon, PollyIconName } from "../../_shared/components/PollyIcon";

type Props = {
  icon?: PollyIconName;
  header: string;
  text?: string | React.ReactNode;
};

export const Banner: React.FC<Props> = ({ icon, header, text }) => {
  return (
    <Flex column hAlign="center" className="bnr-unit">
      <Header
        as="h3"
        content={
          <Flex gap="gap.small" vAlign="center">
            {icon && <PollyIcon icon={icon} ignoreTheme label={header} />}
            {!icon && <Text>{header}</Text>}
          </Flex>
        }
      />
      {text && <Text content={text} />}
    </Flex>
  );
};
